import { Button, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const AddCustomColumnsWrapper = styled('div')`
  display: flex;
  border-radius: 18px;
  border: 1px solid;
  padding: 5px 2px 5px 13px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-color: ${colors.primary};
  color: ${colors.primary};
  gap: 5px;
  margin-left: auto;
  box-shadow: 2px 4px 2px 0px #2c607b26;
  margin-right: 10px;
`

export const StyledAddColumnsButton = styled('span')`
  background-color: ${colors.primary};
  border-radius: 15px;
  color: ${colors.white};
  line-height: 19px;
  padding: 3px 5px;
  display: flex;
  cursor: pointer;
`

export const AddNewCategoryButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  gap: 8px;
  cursor: pointer;
  color: ${colors.black};
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid ${colors.lightGrey};
  width: 100%;
`

export const CustomCategoryRowWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 3px;
  border: 1px solid ${colors.lightGrey};
  background: #f8f8f8;
  padding: 8px;

  ${(props: { $grey: boolean }) => `${
    props.$grey
      ? `
        background:${colors.lightGrey};
        `
      : null
  }
  `}

  ${(props: { $isDragged: boolean }) => `${
    props.$isDragged
      ? `
          background: ${colors.grey};
          opacity: 0.5;
        `
      : null
  }
 `}
`

export const CategoryRowWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`

export const CustomCategoryNameWrapper = styled('div')`
  padding: 0 5px;
  white-space: break-spaces;
  min-height: 25px;
  display: flex;
  align-items: center;
  word-break: break-all;
  flex: 1 1 auto;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 2px;

  &:hover {
    border: 1px solid ${colors.darkGray};
  }
`

export const EditCustomCategoryTextField = styled(TextField)`
  width: 100%;

  & .MuiInputBase-root {
    min-height: 20px;
  }

  & .MuiInputBase-input {
    padding: 5px;
  }
`

export const ValidationMessage = styled('span')`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 19.92px;
  letter-spacing: 0.4000000059604645px;
  text-align: left;
  color: ${colors.error};
`
